module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "4FixedSetting.9dc42b11.svg";